import { IApiResponse } from '@/common/models/interface'
import { AnnouncementRsp, GupStatisticRsp, ArticleRsp } from '@/services/models/Home'
import HomeService from '@/services/home.service'
import _ from 'lodash'
import EhStatisticRsp from '../services/models/Home/EhStatisticRsp'
import { AxiosResponse } from 'axios'

const homeService = new HomeService()

export default {
  state: {
    article: [] as ArticleRsp[],
    announcement: [] as AnnouncementRsp[],
    gupStatistic: {} as GupStatisticRsp,
    ehStatistic: {} as EhStatisticRsp,
    video: {} as AnnouncementRsp,
    totalCount: 0 as number,
    isGupPosOpen: true
  },

  getters: {
    article: (state: any) => state.article,
    announcement: (state: any) => state.announcement,
    gupStatistic: (state: any) => state.gupStatistic,
    ehStatistic: (state: any) => state.ehStatistic,
    video: (state: any) => state.video,
    totalCount: (state: any) => state.totalCount,
    isGupPosOpen: (state: any) => state.isGupPosOpen
  },

  mutations: {
    setAnnouncement(state: any, announcementRsp: any) {
      const announcement = { ...announcementRsp.data.data }
      _.forEach(announcement, (a: AnnouncementRsp) => {
        a.updatedOn = new Date(Date.parse(a.updatedOn)).toLocaleString()
      })
      state.announcement = announcement
      state.totalCount = announcementRsp.headers['x-total-count']
    },

    setArticle(state: any, articleRsp: IApiResponse<ArticleRsp[]>) {
      state.article = { ...articleRsp.data }
    },

    setGupStatistic(state: any, gupStatisticRsp: IApiResponse<GupStatisticRsp>) {
      state.gupStatistic = { ...gupStatisticRsp.data }
    },

    setEhStatistic(state: any, ehStatisticRsp: AxiosResponse<IApiResponse<EhStatisticRsp>>) {
      state.ehStatistic = { ...ehStatisticRsp.data.data }
    },
    setVideo(state: any, video: AxiosResponse<IApiResponse<AnnouncementRsp>>) {
      state.video = video.data.data
    },
    setIsGupPosOpen(state: any, status: boolean) {
      state.isGupPosOpen = status
    }
  },
  actions: {
    async getGupStatistic({ commit }: { commit: any; state: any }) {
      commit('setGupStatistic', await homeService.getGupStatistic())
    },

    async getEhStatistic({ commit }: { commit: any; state: any }) {
      try {
        commit('setEhStatistic', await homeService.getEhStatistic())
        return true
      } catch (err) {
        return false
      }
    },

    async getArticle({ commit }: { commit: any; state: any }) {
      const data = await homeService.getArticle()
      commit('setArticle', data)
    },

    async getAnnouncement({ commit }: { commit: any; state: any }, param: any) {
      const res = await homeService.getAnnouncement(param)
      commit('setAnnouncement', res)
    },

    async getVideo({ commit }: { commit: any; state: any }) {
      const res = await homeService.getVideo()
      commit('setVideo', res)
    }
  },

  namespaced: true
}
